import { useEffect, useState } from "react";
import { decrypt } from "../../Utilities/utils";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import getConfigJson from "./Helpers/getConfigJson";
import getFormConfig from "./Helpers/getFormConfig";
import { PROPOSAL_CREATION_PAGE_ROUTE } from "../routes";

const useCreateQuote = () => {
  const [formConfigJSON, setFormConfigJSON] = useState({}); // To render form
  const [quickQuoteDetails, setQuickQuoteDetails] = useState({}); // Filled in QQ Form (To reinitialize form)
  const [activeStep, setActiveStep] = useState(0); // Steps/Tabs
  const [numberOfInsureds, setNumberOfInsureds] = useState(1); // For Primary/Insureds Details
  const [disableBuy, setDisableBuy] = useState(false);

  const navigate = useNavigate();

  const { productRef, transferDataId } = useParams();

  const { state } = useLocation();
  const { formikValuesId } = state ?? {};
  // console.log("productRef: ", productRef);
  // console.log("transferDataId: ", transferDataId);

  const decryptedProductRef = decrypt(decodeURIComponent(productRef));
  // console.log("decryptedProductRef in cq: ", decryptedProductRef);
  const decryptedTransferDataId = decrypt(decodeURIComponent(transferDataId));
  // console.log("decryptedTransferDataId in cq: ", decryptedTransferDataId);

  useEffect(() => {
    // Get config json to build form
    getConfigJson(decryptedProductRef, decryptedTransferDataId)
      .then((res) => {
        console.log("res", res);
        if (res === null) {
          alert("Failed to load form, try again after sometimes..");
          return;
        }

        setFormConfigJSON(res.config_json);
        setQuickQuoteDetails(res.quick_quote_details);

        setNumberOfInsureds(res.quick_quote_details.number_of_insured);
      })
      .catch((error) => {
        console.log("error: ", error);
        alert("Failed to load form, try again after sometimes..");
      });
  }, [decryptedProductRef, decryptedTransferDataId]);

  // Get the initial values, validation schema and steps for the form
  const { initialValues, validationSchema, steps } = getFormConfig(
    formConfigJSON,
    quickQuoteDetails,
    activeStep
  );

  const totalSteps = () => {
    return steps.length;
  };

  const handleBack = () => {
    if (activeStep !== 0) {
      window.scrollTo(0, 0);
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
      //formikContext.validateForm()
    } else {
      navigate(-1);
    }
  };

  const isLastStep = () => {
    //setDisableBuy(true)
    return activeStep === totalSteps() - 1;
  };

  const onSubmit = async (values, { setSubmitting }) => {
    setDisableBuy(true);
    if (!isLastStep()) {
      setDisableBuy(false);
      window.scrollTo(0, 0);
      setActiveStep(activeStep + 1);
      return;
    }

    navigate(
      `${PROPOSAL_CREATION_PAGE_ROUTE}/?id=${encodeURIComponent(
        transferDataId
      )}`,
      {
        state: { values, formikValuesId },
      }
    ); // TODO: Use context API
  };

  return {
    initialValues,
    validationSchema,
    steps,
    activeStep,
    setActiveStep,
    formConfigJSON,
    numberOfInsureds,
    disableBuy,
    isLastStep,
    handleBack,
    onSubmit,
  };
};

export default useCreateQuote;
